import { InlineItems } from "./InlineItems";
import { InteractiveItems } from "./InteractiveItems";

export const SocialSharing = ({ inline, ...props }) =>
  inline ? <InlineItems {...props} /> : <InteractiveItems {...props} />;
